import { render, staticRenderFns } from "./FornecedorJustificativa.vue?vue&type=template&id=36dfd9a9"
import script from "./FornecedorJustificativa.vue?vue&type=script&lang=js"
export * from "./FornecedorJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports